/**
 * Added-to-basket panel -> one-tap developer card -> "Other peroxides" pop-out (spec §3.1).
 * The card replaced the "Developers" button on 2026-10-19 (owner, approved from the mockup):
 * 7% of shoppers opened the button, 45% of those added. Colour/bleach adds only.
 * Brand-matched developer first; "Show other peroxide options" leads with HDS own brand;
 * brand-locked lines never show others. Full price, tier prices.
 */
(function () {
  'use strict';

  function pairFor(map, handle) {
    if (!map || !map.pairs || !handle) return null;
    return map.pairs[handle] || null;
  }

  function ratioMult(ratio) {
    var parts = String(ratio || '').split(':');
    var mult = parts.length === 2 ? parseFloat(parts[1]) / parseFloat(parts[0]) : NaN;
    return isNaN(mult) ? null : mult;
  }

  function sizeMl(title) { var m = /(\d+)\s*ml\b/i.exec(title || ''); return m ? parseInt(m[1], 10) : null; }

  /**
   * Developer the WHOLE basket needs for one developer family: every colour line whose pair
   * points at that family counts (Koleston is one line per shade), each at its own ratio and
   * tube size. ml is null when any counted line has no stated ratio or no ml size - the copy
   * then states the ratio only rather than inventing a total.
   */
  function basketNeed(map, items, familyId) {
    var tubes = 0, ml = 0, known = true, ratios = {};
    (items || []).forEach(function (it) {
      var pair = it && pairFor(map, it.handle);
      if (!pair || pair.developer !== familyId) return;
      var q = Number(it.quantity) || 0;
      if (!q) return;
      tubes += q;
      ratios[pair.ratio || ''] = true;
      var mult = ratioMult(pair.ratio), size = sizeMl(it.product_title);
      if (mult === null || !size) known = false;
      else ml += q * size * mult;
    });
    var rs = Object.keys(ratios);
    return { tubes: tubes, ml: (tubes && known) ? Math.round(ml) : null,
             ratio: rs.length === 1 && rs[0] ? rs[0] : null };
  }

  /**
   * Starting quantity for one developer row: enough of THIS size to cover what the basket
   * needs (720ml -> 1 x 1L, or 12 x 60ml). 1 when the need or the size is unknown. Max 99.
   */
  function suggestQty(needMl, sizeLabel) {
    var t = String(sizeLabel || '').toLowerCase();
    var m = /(\d+(?:\.\d+)?)\s*(ml|l|litre|liter)\b/.exec(t);
    var size = m ? parseFloat(m[1]) * (m[2] === 'ml' ? 1 : 1000) : null;
    if (!needMl || !size) return 1;
    return Math.max(1, Math.min(99, Math.ceil(needMl / size)));
  }

  /**
   * Most of one variant a shopper can still add: what is in stock minus what is already in
   * their basket. stock null/undefined = untracked or oversellable -> uncapped (99).
   */
  function capFor(stock, inCart) {
    if (stock === null || stock === undefined) return 99;
    return Math.max(0, Math.min(99, Number(stock) - (Number(inCart) || 0)));
  }

  /** need: basketNeed() result; null when the basket read failed (falls back to the pair's ratio). */
  function buttonCopy(pair, need) {
    var ratio = (need && need.tubes) ? need.ratio : pair.ratio;
    var ml = need && need.ml;
    var sub;
    if (ml && ratio) sub = 'Mixes ' + ratio + ' — your basket needs ' + ml + 'ml';
    else if (ml) sub = 'Your basket needs ' + ml + 'ml of developer';
    else if (ratio) sub = 'Mixes ' + ratio;
    else sub = 'Developer for ' + (pair.colour_name || 'your colour');
    return { title: 'Developers', sub: sub };
  }

  /** Product handles to fetch for a family; ownOnly = the matching family alone (no others). */
  function handlesFor(m, familyId, ownOnly) {
    return window.CartDeveloperUpsell.offerHandles(m, familyId, !ownOnly);
  }

  /**
   * Spec §9: the "Developers" button is earned only when the matching developer family has at
   * least one strength in stock right now (Color Touch emulsion sold out = no button).
   * dev = window.CartDeveloperUpsell; prods = {handle: product.js payload or null}.
   */
  function buttonEarned(dev, m, pair, prods) {
    if (!dev || !m || !pair || !m.families || !m.families[pair.developer]) return false;
    var o = dev.developerOffer(m, pair.developer, prods || {}, { defaultStrength: pair.default_strength });
    return !!(o && o.strengths.length);
  }

  /**
   * The developer as a one-tap card (owner, 2026-10-19, approved from the mockup: only 7% of
   * shoppers opened the Developers button, but 45% of those added). Shown on the
   * added-to-basket panel in place of the button, and in the drawer (assets/cart-upsell.js).
   * offer = developerOffer() WITHOUT others: the matching brand's own rows only. The first
   * in-stock row of the strength is the one offered (map sizes run largest first), with the
   * quantity the basket needs. null = nothing to offer at that strength.
   */
  function cardView(offer, strength, needMl, prods) {
    if (!offer || !offer.strengths.length) return null;
    var s = offer.strengths.indexOf(strength) !== -1 ? strength : offer.defaultStrength;
    var r = s ? offer.rows(s)[0] : null;
    if (!r) return null;
    var one = offer.strengths.length === 1;
    var detail = function (x) { return (one ? (/%$/.test(s) ? s + ' · ' : '') : s + ' · ') + x.size; };
    // Every size the brand has at this strength, in map order (largest first): one swipe card
    // each (owner, 2026-11-02, layout D). rows[0] is what the single card used to offer.
    var rows = offer.rows(s).map(function (x) {
      var px = (prods && prods[x.handle]) || {};
      return { row: x, label: offer.label, detail: detail(x), img: px.featured_image || '', qty: suggestQty(needMl, x.size) };
    });
    return { strength: s, strengths: one ? [] : offer.strengths, row: r, rows: rows,
             name: offer.label + (one && /%$/.test(s) ? ' ' + s : '') + ' · ' + r.size,
             img: rows[0].img, qty: rows[0].qty };
  }

  /** Image thumb at 88px, or a blank square. */
  function cardImg(src, esc) {
    return src ? '<img class="dvc__img" src="' + esc(String(src).replace(/(\.[a-z]+)(\?|$)/i, '_88x$1$2')) +
      '" alt="" width="56" height="56" loading="lazy">' : '<span class="dvc__img"></span>';
  }

  /** Position dots under a swipe rail (decorative; the cards themselves are the content). */
  function dotsHtml(n, cls) {
    if (n < 2) return '';
    var d = '';
    for (var i = 0; i < n; i++) d += '<i' + (i ? '' : ' class="on"') + '></i>';
    return '<div class="' + cls + '" aria-hidden="true">' + d + '</div>';
  }

  /**
   * The card's HTML (owner, 2026-11-02: layout D - one swipe card per size).
   * v = cardView() plus { sub, chips, others, pending, slides: [{ row, label, detail, img, qty,
   * max, priceHtml, added }] }; esc = CartUpsell.esc. chips = show the strength chips (the
   * drawer has no pop-out to change strength in; the panel card does). data-dvc-* hooks are
   * scoped by whichever surface's container holds it.
   */
  function cardHtml(v, esc) {
    var slides = v.slides || [];
    var chips = v.chips && v.strengths.length ? '<div class="dvc__chips" role="group" aria-label="Strength">' +
      v.strengths.map(function (s) {
        return '<button type="button" class="dvc__chip" data-dvc-strength="' + esc(s) + '" aria-pressed="' + (s === v.strength) + '">' + esc(s) + '</button>';
      }).join('') + '</div>' : '';
    var cards = slides.map(function (c) {
      var r = c.row, k = esc(r.variantId), q = c.qty, max = c.max == null ? 99 : c.max;
      var busy = v.pending != null && String(v.pending) === String(r.variantId);
      var off = c.added || v.pending != null;
      return '<div class="dvc__card" data-dvc-slide="' + k + '">' +
        '<div class="dvc__hd">' + cardImg(c.img, esc) + '<div class="dvc__name"><b>' + esc(c.label) + '</b>' +
          '<span class="dvc__det">' + esc(c.detail) + '</span>' + (c.priceHtml || '') + '</div></div>' +
        '<div class="dvc__act">' +
          '<div class="dvc__qty" role="group" aria-label="Quantity">' +
            '<button type="button" class="dvc__qb" data-dvc-dec="' + k + '" aria-label="Fewer"' + (q <= 1 ? ' disabled' : '') + '>−</button>' +
            '<span class="dvc__qn" data-dvc-q="' + k + '" aria-live="polite">' + q + '</span>' +
            '<button type="button" class="dvc__qb" data-dvc-inc="' + k + '" aria-label="More"' + (q >= max ? ' disabled' + (max < 99 ? ' title="Only ' + max + ' available"' : '') : '') + '>+</button></div>' +
          '<button type="button" class="dvc__add' + (c.added ? ' dvc__add--done' : busy ? ' dvc__add--busy' : '') + '" data-dvc-add="' + k + '" data-dvc-h="' + esc(r.handle) +
            '" data-dvc-p="' + esc(r.price) + '"' + (off ? ' disabled' : '') + (busy ? ' aria-busy="true"' : '') + '>' +
            (c.added ? '✓ Added' : busy ? '<span class="dvc__spin" aria-hidden="true"></span><span class="dvc__vh">Adding</span>' : 'Add') + '</button>' +
        '</div></div>';
    }).join('');
    return '<div class="dvc" data-dvc>' +
      (v.sub ? '<p class="dvc__head">' + esc(v.sub) + '</p>' : '') + chips +
      '<div class="dvc__rail' + (slides.length < 2 ? ' dvc__rail--one' : '') + '" data-dvc-rail>' + cards + '</div>' +
      dotsHtml(slides.length, 'dvc__dots') +
      (v.others ? '<button type="button" class="dvc__more" data-cn-dev-open>' + esc(v.others) + ' ›</button>' : '') +
      '</div>';
  }

  window.CartDevPopout = { pairFor: pairFor, buttonCopy: buttonCopy, basketNeed: basketNeed, suggestQty: suggestQty, capFor: capFor, handlesFor: handlesFor, buttonEarned: buttonEarned,
                           cardView: cardView, cardHtml: cardHtml, dotsHtml: dotsHtml };
  if (typeof document === 'undefined' || !document.addEventListener) return;

  var cfg = window.__cartUpsell || {};
  var U = window.CartUpsell, D = window.CartDeveloperUpsell;
  var mapP = null, cache = {}, current = null, lastFocus = null, openSeq = 0;
  var st = { strength: null, others: false, added: {} };

  function json(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  // Synchronous mirrors of what has already arrived. The panel paints in the same task that
  // fires cart-notification:open, so if everything is here the button is in that first paint.
  var sync = { map: null, prod: {}, cart: null };
  function product(h) {
    return cache[h] || (cache[h] = json('/products/' + h + '.js').then(function (p) { sync.prod[h] = p; return p; }));
  }
  function map() { return mapP || (mapP = json(cfg.devMapUrl).then(function (m) { sync.map = m; return m; })); }

  /** The basket with the just-added line folded in (add.js returns the line's new total). */
  function withLine(items, line) {
    var out = (items || []).filter(function (it) { return !line || it.key !== line.key; });
    if (line) out.push(line);
    return out;
  }

  /**
   * Warm everything the button needs before anyone adds: the developer map, and on a colour
   * product page that colour's developer products, their stock, and the basket. Then the
   * added-to-basket panel opens with the Developers button already in it, not popping in.
   */
  function prefetch() {
    if (!U || !U.gate(cfg.audience, arm(), cfg.staff)) return;
    var mm = /\/products\/([^\/?#]+)/.exec(location.pathname);
    var here = mm ? decodeURIComponent(mm[1]) : '';
    var go = function () {
      map().then(function (m) {
        var pair = m && here && pairFor(m, here);
        if (!pair || !m.families || !m.families[pair.developer]) return;
        // Only what the BUTTON needs: the matching developer's products (in-stock check) and
        // the basket (ml text). Stock counts and the other peroxides wait for warmPopout().
        handlesFor(m, pair.developer, true).forEach(product);
        json('/cart.js').then(function (c) { if (c) sync.cart = c; });
      });
    };
    // After the page has finished its own work, never competing with it.
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 4000 });
    else setTimeout(go, 1500);
  }

  /** The Developers button is showing: fetch what the pop-out needs before it is clicked. */
  function warmPopout(m, pair) {
    handlesFor(m, pair.developer).forEach(function (h) { product(h); stock(h); });
  }

  // The one-tap card on the panel (cardView/cardHtml above). inl = its state for this add.
  var inl = null;

  function paintCard(slot, m, pair, need, item, prods) {
    var copy = buttonCopy(pair, need);
    current = { map: m, pair: pair, colourHandle: item.handle, copy: copy, needMl: need && need.ml };
    var fam = m.families[pair.developer];
    inl = { slot: slot, offer: D.developerOffer(m, pair.developer, prods, { defaultStrength: pair.default_strength }),
            prods: prods, strength: null, qty: {}, added: {}, stock: {}, inCart: inCartOf(sync.cart),
            // Every size is already a swipe card; the link is for strength (and brand).
            others: '' };
    inl.strength = inl.offer && inl.offer.defaultStrength;
    if (inl.offer) inl.others = fam.locked ? (inl.offer.strengths.length > 1 ? 'Other strengths' : '') : 'Other strengths & brands';
    if (!drawCard()) return;
    var v = cardView(inl.offer, inl.strength, current.needMl, prods);
    if (U.track) U.track('upsell_impression', { surface: 'panel', offer_id: 'panel|' + item.handle,
      source_handle: item.handle, strength: v.strength,
      offered: v.rows.map(function (c, i) { return { handle: c.row.handle, variant_id: c.row.variantId, position: i, price_pence: c.row.price }; }) });
    // Stock caps the quantity stepper; it lands after the first paint (only +/- state changes).
    var mine = inl;
    Promise.all(handlesFor(m, pair.developer, true).map(stock)).then(function (ss) {
      if (inl !== mine) return;
      ss.forEach(function (s) { for (var k in s) if (Object.prototype.hasOwnProperty.call(s, k)) inl.stock[k] = s[k]; });
      // A variant whose remaining stock is already all in the basket is not offerable.
      var capped = {};
      Object.keys(prods).forEach(function (h) {
        var p = prods[h];
        capped[h] = p ? Object.assign({}, p, { variants: (p.variants || []).map(function (vv) {
          return Object.assign({}, vv, { available: !!vv.available && cardMax(vv.id) > 0 });
        }) }) : null;
      });
      inl.offer = D.developerOffer(m, pair.developer, capped, { defaultStrength: pair.default_strength });
      if (inl.offer && inl.offer.strengths.indexOf(inl.strength) === -1) inl.strength = inl.offer.defaultStrength;
      drawCard();
    });
  }

  function inCartOf(cart) {
    var o = {};
    ((cart && cart.items) || []).forEach(function (it) { o[it.variant_id] = (o[it.variant_id] || 0) + (it.quantity || 0); });
    return o;
  }

  function cardMax(id) { return capFor(inl.stock[id], inl.inCart[id]); }

  /** Light the dot of the card nearest the rail's left edge (the last one at the end). */
  function railDots(rail) {
    var d = rail.nextElementSibling;
    if (!d || !/__dots$/.test(d.className)) return;
    var cards = rail.children, left = rail.getBoundingClientRect().left, on = 0, best = Infinity;
    if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2) on = cards.length - 1;
    else for (var i = 0; i < cards.length; i++) {
      var dist = Math.abs(cards[i].getBoundingClientRect().left - left);
      if (dist < best) { best = dist; on = i; }
    }
    for (var j = 0; j < d.children.length; j++) d.children[j].className = j === on ? 'on' : '';
  }

  /** (Re)draw the panel card from inl. false = nothing offerable (slot hidden). */
  function drawCard() {
    var slot = inl && inl.slot;
    var v = inl && cardView(inl.offer, inl.strength, current && current.needMl, inl.prods);
    if (!slot || !v) { if (slot) { slot.hidden = true; slot.innerHTML = ''; } return false; }
    var slides = v.rows.map(function (c) {
      var id = c.row.variantId, max = cardMax(id);
      inl.qty[id] = Math.max(1, Math.min(inl.qty[id] || c.qty, max || 1));
      return Object.assign({}, c, { qty: inl.qty[id], max: max, added: !!inl.added[id],
        priceHtml: U.priceMarkup(c.row.handle, c.row.price, U.tierPriced()) });
    });
    // A redraw (stock / basket refresh) keeps the card the shopper has swiped to.
    var old = slot.querySelector('[data-dvc-rail]'), x = old ? old.scrollLeft : 0;
    slot.innerHTML = cardHtml(Object.assign({}, v, { sub: current.copy.sub, slides: slides, chips: false,
      others: inl.others, pending: inl.pending }), U.esc);
    var rail = slot.querySelector('[data-dvc-rail]');
    if (rail && x) { rail.scrollLeft = x; railDots(rail); }
    slot.hidden = false;
    if (window.B2BListingPrices) window.B2BListingPrices.apply();
    return true;
  }

  /** +/- on the panel card, in place: nothing redraws, so focus and layout never move. */
  function cardBump(id, delta) {
    var max = cardMax(id);
    if (max < 1) return;
    var q = Math.max(1, Math.min(max, (inl.qty[id] || 1) + delta));
    inl.qty[id] = q;
    var n = inl.slot.querySelector('[data-dvc-q="' + id + '"]');
    if (n) n.textContent = String(q);
    var dec = inl.slot.querySelector('[data-dvc-dec="' + id + '"]'), inc = inl.slot.querySelector('[data-dvc-inc="' + id + '"]');
    if (dec) dec.disabled = q <= 1;
    if (inc) { inc.disabled = q >= max; inc.title = (q >= max && max < 99) ? 'Only ' + max + ' available' : ''; }
  }

  function cardAdd(btn) {
    if (!inl || inl.pending != null) return;
    var id = btn.getAttribute('data-dvc-add'), qty = inl.qty[id] || 1, colour = current.colourHandle;
    // On inl, not the button: a stock / basket refresh or a strength chip redraws the card
    // mid-add, and drawCard() must repaint it busy rather than hand back a live Add.
    var mine = inl;
    mine.pending = id;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('dvc__add--busy');
    btn.innerHTML = '<span class="dvc__spin" aria-hidden="true"></span><span class="dvc__vh">Adding</span>';
    var payload = { items: [{ id: id, quantity: qty, properties: {
      _dev_upsell_source: colour, _dev_upsell_surface: 'toast-inline', _dev_upsell_choice: 'branded' } }] };
    var drawer = document.querySelector('cart-drawer');
    var sec = (drawer && drawer.getSectionsToRender) ? drawer : panel();
    if (sec && sec.getSectionsToRender) {
      payload.sections = sec.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || '');
        if (U.track) U.track('upsell_add', { surface: 'panel', offer_id: 'panel|' + colour,
          handle: btn.getAttribute('data-dvc-h') || '', variant_id: id, qty: qty, group: 'branded',
          strength: inl && inl.strength, price_pence: Number(btn.getAttribute('data-dvc-p')) || null });
        mine.added[id] = true; mine.pending = null;
        // The panel re-renders for the developer just added (it shows the shopper it landed);
        // that re-fires cart-notification:open, which clears this card - a developer has no pair.
        release();
        var np = panel(), line = res && res.items && res.items[0];
        if (np && np.renderContents && line) np.renderContents(Object.assign({}, line, { sections: res.sections }));
        else if (np && np.resettle) np.resettle(res);
        else if (drawer && drawer.renderContents && res.sections) drawer.renderContents(res);
      })
      .catch(function (err) {
        mine.pending = null;
        var h = btn.getAttribute('data-dvc-h') || '';
        if (U.track) U.track('upsell_add_failed', { surface: 'panel', handle: h, reason: (err && err.message) || '' });
        if (inl !== mine) return;   // the panel moved on to another colour; nothing to restore
        // The card may have been redrawn while the add was in flight: use the live button.
        if (inl.slot && !inl.slot.contains(btn)) {
          if (!drawCard()) return;
          btn = inl.slot.querySelector('[data-dvc-add]');
          if (!btn) return;
        }
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('dvc__add--busy');
        btn.textContent = 'Add';
        var card = btn.closest('.dvc');
        if (card) {
          var e = card.querySelector('.dvc__err');
          if (!e) { e = document.createElement('p'); e.className = 'dvc__err'; e.setAttribute('role', 'alert'); card.appendChild(e); }
          e.textContent = (err && err.message) || 'That could not be added. Please try again.';
        }
      });
  }

  function box() { return document.getElementById('dev-popout'); }
  function arm() { return document.documentElement.getAttribute('data-ab-cart_upsell'); }

  function onPanelOpen(e) {
    var slot = document.querySelector('[data-cn-dev]');
    if (!slot) return;
    // The pop-out is open: this is the panel re-rendering for a developer the pop-out itself
    // just added. Keep the pop-out's session (and the panel's Developers button) as they are.
    var open0 = box();
    if (open0 && !open0.hidden) return;
    slot.hidden = true; slot.innerHTML = '';
    current = null; inl = null;
    var seq = ++openSeq;
    if (!U || !D || !U.gate(cfg.audience, arm(), cfg.staff)) return;
    var item = e.detail && e.detail.item;
    if (item && !item.handle && item.items && item.items[0]) item = item.items[0];

    // Fast path: everything already warm -> paint the button NOW, in the panel's first paint,
    // then refine the "needs Xml" text from the real basket (text only, nothing moves).
    var ms = sync.map, ps0 = ms && pairFor(ms, item && item.handle);
    if (ps0 && ms.families && ms.families[ps0.developer]) {
      var hs0 = handlesFor(ms, ps0.developer, true);
      if (hs0.every(function (h) { return Object.prototype.hasOwnProperty.call(sync.prod, h); })) {
        var prods0 = {}; hs0.forEach(function (h) { prods0[h] = sync.prod[h]; });
        if (!buttonEarned(D, ms, ps0, prods0)) return;
        var items0 = withLine(sync.cart && sync.cart.items, item);
        paintCard(slot, ms, ps0, basketNeed(ms, items0, ps0.developer), item, prods0);
        warmPopout(ms, ps0);
        json('/cart.js').then(function (c) {
          if (!c || seq !== openSeq || !inl) return;
          sync.cart = c;
          var need = basketNeed(ms, c.items, ps0.developer);
          current.copy = buttonCopy(ps0, need); current.needMl = need && need.ml;
          // The real basket: the head line and the suggested quantity (until the shopper sets one).
          inl.inCart = inCartOf(c); inl.qty = {};
          drawCard();
        });
        return;
      }
    }

    var m, pair, prods = {};
    map().then(function (mm) {
      m = mm;
      pair = m && pairFor(m, item && item.handle);
      if (!pair || !m.families || !m.families[pair.developer]) return null;
      // Spec §9: no card unless the matching developer has a strength in stock right now.
      var hs = handlesFor(m, pair.developer, true);
      return Promise.all(hs.map(product)).then(function (ps) {
        hs.forEach(function (h, i) { prods[h] = ps[i]; });
        return buttonEarned(D, m, pair, prods);
      });
    }).then(function (inStock) {
      if (!inStock) return null;
      // The whole basket, not just the line just added: one Koleston line is one shade.
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (cart) { return { cart: cart }; });
    }).then(function (res) {
      // A later add re-ran this handler while we were fetching: its answer wins.
      if (!res || seq !== openSeq) return;
      if (res.cart) sync.cart = res.cart;
      var need = res.cart ? basketNeed(m, res.cart.items, pair.developer) : null;
      paintCard(slot, m, pair, need, item, prods);
      warmPopout(m, pair);
    });
  }

  var stockCache = {};
  function stock(h) {
    return stockCache[h] || (stockCache[h] = fetch('/products/' + h + '?section_id=api-variant-stock', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { var m = /data-variant-stock>([^<]*)</.exec(t || ''); return m ? JSON.parse(m[1]) : {}; })
      .catch(function () { return {}; }));
  }

  function maxOf(id) { return capFor(current.stock[id], current.inCart[id]); }

  function open() {
    if (!current || !box()) return;
    lastFocus = document.activeElement;
    st = { strength: null, others: false, othersSeen: false, added: {}, qty: {} };
    current.reserved = null;
    current.placed = false;
    var hs = handlesFor(current.map, current.pair.developer);
    var cartP = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    Promise.all([Promise.all(hs.map(product)), Promise.all(hs.map(stock)), cartP]).then(function (all) {
      var ps = all[0], ss = all[1], cart = all[2];
      current.stock = {}; current.inCart = {};
      ss.forEach(function (m) { for (var k in m) if (Object.prototype.hasOwnProperty.call(m, k)) current.stock[k] = m[k]; });
      ((cart && cart.items) || []).forEach(function (it) {
        current.inCart[it.variant_id] = (current.inCart[it.variant_id] || 0) + (it.quantity || 0);
      });
      // A variant whose remaining stock is already all in the basket can't be added: treat
      // it as out of stock so it never gets a row, a chip or a fallback slot.
      var prods = {};
      hs.forEach(function (h, i) {
        var p = ps[i];
        prods[h] = p ? Object.assign({}, p, { variants: (p.variants || []).map(function (v) {
          return Object.assign({}, v, { available: !!v.available && maxOf(v.id) > 0 });
        }) }) : null;
      });
      current.offer = D.developerOffer(current.map, current.pair.developer, prods,
        { includeOthers: true, defaultStrength: current.pair.default_strength });
      current.prods = prods;
      if (!current.offer || !current.offer.strengths.length) return;
      // Opened from the panel card: carry its strength over.
      st.strength = inl && current.offer.strengths.indexOf(inl.strength) !== -1 ? inl.strength : current.offer.defaultStrength;
      draw();
      box().hidden = false;
      draw();   // now visible: measure every strength and reserve the tallest
      document.body.classList.add('dev-popout-open');
      if (U.track) U.track('upsell_impression', { surface: 'popout', offer_id: 'popout|' + current.colourHandle,
        source_handle: current.colourHandle, strength: st.strength,
        offered: current.offer.rows(st.strength).map(function (r, i) {
          return { handle: r.handle, variant_id: r.variantId, position: i, price_pence: r.price, group: r.group };
        }) });
      // One window at a time (owner, 2026-11-02): the sheet replaces the added-to-basket
      // panel instead of stacking on it. An add re-renders the panel for the developer just
      // added (renderContents opens it), so the shopper still gets the confirmation.
      var pn = panel(); if (pn && pn.hide && !pn.hidden) pn.hide();
      var first = box().querySelector('button');
      if (first) first.focus();
    });
  }

  function panel() { return document.querySelector('cart-notification'); }
  // Hold the added-to-basket panel open while the pop-out is up. The panel resets its own
  // `interacting` flag on mouseleave/focusout; these listeners run after its own and re-assert.
  function hold() {
    var p = panel(); if (!p) return;
    p.interacting = true;
    if (p.syncDismissTimer) p.syncDismissTimer();
  }
  function release() {
    var p = panel(); if (!p) return;
    p.interacting = false;
    if (p.syncDismissTimer) p.syncDismissTimer();
  }
  function reassert() { var b = box(); if (b && !b.hidden) hold(); }
  /**
   * A touch on the panel card: restart the panel's auto-dismiss countdown instead of pinning
   * it open. A phone has no mouseleave and may never focusout, so a hold() there would keep the
   * panel up until the shopper closes it. Runs after the click's own focusin.
   */
  var lastPointer = '';
  function nudge() {
    var p = panel(); if (!p) return;
    p.interacting = false;
    if (p.syncDismissTimer) p.syncDismissTimer();
  }

  function close() {
    var b = box(); if (!b) return;
    b.hidden = true;
    document.body.classList.remove('dev-popout-open');
    release();
    var t = lastFocus && lastFocus.isConnected && lastFocus.offsetParent !== null ? lastFocus : null;
    if (!t) { var p = panel(); t = p && p.offsetParent !== null ? (p.querySelector('button, a') || p) : document.body; }
    if (t && t.focus) t.focus();
  }

  function refocus(sel) {
    var b = box(), el = sel && b ? b.querySelector(sel) : null;
    if (el && !el.disabled) el.focus();
    else if (b) { var f = b.querySelector('button:not([disabled])'); if (f) f.focus(); }
  }

  function thumb(src) { return String(src).replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2'); }

  /**
   * One swipe card (owner, 2026-11-02, layout D), built to look exactly like the panel card
   * (owner: the sheet looking different was disorientating) - no badge, no note.
   * grp 'p' = the primary (matching) cards, 'o' = other brands.
   */
  function row(r, grp) {
    var key = r.variantId;
    var done = !!st.added[key];
    var p = current.prods[r.handle] || {};
    return '<div class="dvp__card" data-dvp-slide="' + U.esc(key) + '" data-dvp-grp="' + grp + '">' +
      '<div class="dvp__hd">' +
        (p.featured_image ? '<img class="dvp__img" src="' + U.esc(thumb(p.featured_image)) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="dvp__img"></span>') +
        '<div class="dvp__name"><b>' + U.esc(r.groupLabel) + '</b><span class="dvp__det">' + U.esc(r.strength + ' · ' + r.size) + '</span>' +
          U.priceMarkup(r.handle, r.price, U.tierPriced()) + '</div></div>' +
      '<div class="dvp__act">' + stepper(key, r.size) +
        '<button type="button" class="dvp__add' + (done ? ' dvp__add--done' : '') + '" data-dvp-add="' + U.esc(key) + '" data-dvp-h="' + U.esc(r.handle) + '" data-dvp-p="' + U.esc(r.price) +
        '" data-dvp-choice="' + U.esc(r.group) + '"' + (done ? ' disabled' : '') + '>' + (done ? '✓ Added' : 'Add') + '</button></div></div>';
  }

  function qtyOf(key, size) {
    if (!st.qty[key]) st.qty[key] = Math.max(1, Math.min(suggestQty(current.needMl, size), maxOf(key)));
    return st.qty[key];
  }

  function stepper(key, size) {
    var q = qtyOf(key, size), k = U.esc(key), max = maxOf(key);
    return '<div class="dvp__qty" role="group" aria-label="Quantity">' +
      '<button type="button" class="dvp__qb" data-dvp-dec="' + k + '" aria-label="Fewer"' + (q <= 1 ? ' disabled' : '') + '>\u2212</button>' +
      '<span class="dvp__qn" data-dvp-q="' + k + '" aria-live="polite">' + q + '</span>' +
      '<button type="button" class="dvp__qb" data-dvp-inc="' + k + '" aria-label="More"' + (q >= max ? ' disabled' + (max < 99 ? ' title="Only ' + max + ' available"' : '') : '') + '>+</button></div>';
  }

  /** Change one row's quantity in place: no redraw, so focus and layout never move. */
  function bump(key, delta) {
    var max = maxOf(key);
    if (max < 1) return;
    var q = Math.max(1, Math.min(max, (st.qty[key] || 1) + delta));
    st.qty[key] = q;
    var b = box();
    var n = b.querySelector('[data-dvp-q="' + key + '"]');
    if (n) n.textContent = String(q);
    var dec = b.querySelector('[data-dvp-dec="' + key + '"]'), inc = b.querySelector('[data-dvp-inc="' + key + '"]');
    if (dec) dec.disabled = q <= 1;
    if (inc) { inc.disabled = q >= max; inc.title = (q >= max && max < 99) ? 'Only ' + max + ' available' : ''; }
    var add = b.querySelector('[data-dvp-add="' + key + '"]');
    if (add && st.added[key]) { st.added[key] = false; add.disabled = false; add.className = 'dvp__add'; add.textContent = 'Add'; }
  }

  /**
   * The cards for one strength, as ONE swipe rail: the primary cards first (the brand's rows
   * when it stocks this strength, else the first in-stock fallback - owner: "just show the one
   * we have"), then our own brand, then the other brands in chain order.
   */
  function parts(o, strength) {
    var rows = [].slice.call(o.rows(strength));
    var branded = rows.filter(function (r) { return r.group === 'branded'; });
    var fallbacks = rows.filter(function (r) { return r.group !== 'branded'; });
    var primary = branded.length ? branded : fallbacks.slice(0, 1);
    var rest = branded.length ? fallbacks : fallbacks.slice(1);
    rest = rest.filter(function (r) { return r.group === 'own-brand'; }).concat(rest.filter(function (r) { return r.group !== 'own-brand'; }));
    var cards = primary.map(function (r) { return row(r, 'p'); })
      .concat(rest.map(function (r) { return row(r, 'o'); }));
    var n = cards.length;
    return { primary: '<div class="dvp__rail' + (n < 2 ? ' dvp__rail--one' : '') + '" data-dvp-rail>' + cards.join('') + '</div>' +
      dotsHtml(n, 'dvp__dots'), others: '' };
  }

  /**
   * No layout shift, without padding the pop-out out to a fixed size: once per open, render
   * the variable parts for EVERY strength into an invisible measurer at the real width and
   * reserve the tallest. The pop-out is then exactly as tall as its biggest strength needs
   * and never changes height when a chip is clicked.
   */
  function reserve(body, o) {
    if (current.reserved) return current.reserved;
    // Measuring a display:none pop-out reads 0 for everything; open() draws again once visible.
    if (box().hidden) return { primary: 0, others: 0 };
    var m = document.createElement('div');
    m.className = 'dvp__measure';
    m.setAttribute('aria-hidden', 'true');
    body.appendChild(m);
    var hp = 0, ho = 0;
    o.strengths.forEach(function (s) {
      var p = parts(o, s);
      m.innerHTML = p.primary; hp = Math.max(hp, Math.ceil(m.getBoundingClientRect().height));
      m.innerHTML = p.others;  ho = Math.max(ho, Math.ceil(m.getBoundingClientRect().height));
    });
    body.removeChild(m);
    current.reserved = { primary: hp, others: ho };
    return current.reserved;
  }

  /**
   * Desktop: sit the pop-out where its FULLY OPEN height (other options showing) would be
   * vertically centred, decided once per open. Opening the other options then grows it into
   * space already left for it, and nothing ever re-centres. Mobile stays a bottom sheet.
   */
  function place(body, r) {
    if (current.placed || box().hidden || r.primary === 0) return;
    current.placed = true;
    if (window.innerWidth < 768) { box().style.paddingTop = ''; return; }
    var openH = body.scrollHeight + (st.others ? 0 : r.others);
    box().style.paddingTop = Math.max(24, Math.round((window.innerHeight - openH) / 2)) + 'px';
  }

  function draw() {
    var o = current.offer;
    var chips = o.strengths.map(function (s) {
      return '<button type="button" class="dvp__chip" data-dvp-strength="' + U.esc(s) + '" aria-pressed="' + (s === st.strength) + '">' + U.esc(s) + '</button>';
    }).join('');
    var p = parts(o, st.strength);
    var body = box().querySelector('[data-dvp-body]');
    body.innerHTML =
      '<div class="dvp__head"><div><h2 class="dvp__h" id="dvp-title">' + U.esc((inl && inl.others) || 'Other strengths & brands') + '</h2>' +
      (current.pair.ratio ? '<p class="dvp__sub">' + U.esc(current.copy.sub) + '</p>' : '') + '</div>' +
      '<button type="button" class="dvp__x" data-dvp-close aria-label="Close">✕</button></div>' +
      '<div class="dvp__chips" role="group" aria-label="Strength">' + chips + '</div>' +
      '<div class="dvp__primary">' + p.primary + '</div>';
    var r = reserve(body, o);
    body.querySelector('.dvp__primary').style.minHeight = r.primary + 'px';
    place(body, r);
    if (window.B2BListingPrices) window.B2BListingPrices.apply();
  }

  function add(btn) {
    var id = btn.getAttribute('data-dvp-add');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('dvp__add--busy');
    btn.innerHTML = '<span class="dvp__spin" aria-hidden="true"></span><span class="dvp__vh">Adding</span>';
    var payload = { items: [{ id: id, quantity: st.qty[id] || 1, properties: {
      _dev_upsell_source: current.colourHandle, _dev_upsell_surface: 'toast-popout',
      _dev_upsell_choice: btn.getAttribute('data-dvp-choice') || 'branded' } }] };
    var drawer = document.querySelector('cart-drawer');
    var sec = (drawer && drawer.getSectionsToRender) ? drawer : panel();
    // Ask for the drawer section in the same round trip (as cart-upsell.js add() does) so the
    // panel can swap the drawer and re-arm its price settle off THIS add.
    if (sec && sec.getSectionsToRender) {
      payload.sections = sec.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || '');
        current.inCart[id] = (current.inCart[id] || 0) + (st.qty[id] || 1);
        st.qty[id] = Math.max(1, Math.min(st.qty[id] || 1, maxOf(id)));
        if (U.track) U.track('upsell_add', { surface: 'popout', offer_id: 'popout|' + current.colourHandle,
          handle: btn.getAttribute('data-dvp-h') || '', variant_id: id, qty: st.qty[id] || 1,
          group: btn.getAttribute('data-dvp-choice') || '', strength: st.strength,
          price_pence: Number(btn.getAttribute('data-dvp-p')) || null });
        st.added[id] = true;
        // resettle(), not refresh(): refresh() is the 422 path - it forces the provisional
        // deadline and, with a stale settleStarted, settles at once on the RETAIL subtotal.
        // renderContents() swaps the drawer and re-arms the price settle for the new line.
        // Then close the pop-out: the added-to-basket panel underneath now shows THIS
        // developer, so the shopper sees it landed without having to dismiss the pop-out.
        // The panel comes back for THIS developer (it was hidden while the sheet was up). A
        // developer has no pair, so the colour's card must not come back with it - the panel's
        // open handler skips the slot while the sheet is still open, so clear it here.
        var sl = document.querySelector('[data-cn-dev]');
        if (sl) { sl.hidden = true; sl.innerHTML = ''; }
        inl = null;
        var np = panel();
        var line = res && res.items && res.items[0];
        if (np && np.renderContents && line) np.renderContents(Object.assign({}, line, { sections: res.sections }));
        else if (np && np.resettle) np.resettle(res);
        else if (drawer && drawer.renderContents && res.sections) drawer.renderContents(res);
        else if (drawer && drawer.refresh) drawer.refresh();
        close();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('dvp__add--busy');
        btn.textContent = 'Add';
        // Say why (Shopify's own reason, e.g. stock changed), right under the row tapped.
        var rowEl = btn.closest('.dvp__card');
        if (rowEl) {
          var e = rowEl.querySelector('.dvp__err');
          if (!e) { e = document.createElement('p'); e.className = 'dvp__err'; e.setAttribute('role', 'alert'); rowEl.appendChild(e); }
          e.textContent = (err && err.message) || 'That could not be added. Please try again.';
          if (U.track) U.track('upsell_add_failed', { surface: 'popout', handle: btn.getAttribute('data-dvp-h') || '', reason: (err && err.message) || '' });
        }
      });
  }

  function start() {
    document.addEventListener('cart-notification:open', onPanelOpen);
    prefetch();
    document.addEventListener('b2b:listing-prices', function () { if (box() && !box().hidden && window.B2BListingPrices) window.B2BListingPrices.apply(); });
    // Quantity steps react on pointerdown: a click only fires on release (and after the
    // page's other click handlers), which read as a lag on a control you tap repeatedly.
    document.addEventListener('pointerdown', function (e) {
      lastPointer = e.pointerType || '';
      if (e.button !== 0 || !e.target || !e.target.closest) return;
      // The panel card's +/- (same instant-step rule as the pop-out's).
      var cq = inl && inl.slot.contains(e.target) && (e.target.closest('[data-dvc-dec]') || e.target.closest('[data-dvc-inc]'));
      if (cq) {
        if (cq.disabled) return;
        e.preventDefault();
        if (lastPointer === 'touch' || lastPointer === 'pen') nudge();
        var dec = cq.hasAttribute('data-dvc-dec');
        return cardBump(cq.getAttribute(dec ? 'data-dvc-dec' : 'data-dvc-inc'), dec ? -1 : 1);
      }
      var b = box(); if (!b || b.hidden) return;
      var dq = e.target.closest('[data-dvp-dec]'), iq = e.target.closest('[data-dvp-inc]');
      var btn = dq || iq;
      if (!btn || btn.disabled) return;
      e.preventDefault();   // no focus ring flash / text selection on rapid taps
      bump(btn.getAttribute(dq ? 'data-dvp-dec' : 'data-dvp-inc'), dq ? -1 : 1);
    });
    // Swipe rails (panel card, drawer card, pop-out): scroll does not bubble, so capture.
    document.addEventListener('scroll', function (e) {
      var r = e.target;
      if (!r || !r.matches || !r.matches('[data-dvc-rail], [data-dvp-rail]')) return;
      railDots(r);
      // Swiping the panel card is interacting with it: restart the dismiss countdown.
      if (inl && inl.slot && inl.slot.contains(r) && (lastPointer === 'touch' || lastPointer === 'pen')) nudge();
      // Other brands swiped into view = what "Show other peroxide options" used to count.
      if (r.hasAttribute('data-dvp-rail') && current && !st.othersSeen) {
        var o = r.querySelector('[data-dvp-grp="o"]');
        if (o && o.getBoundingClientRect().left < r.getBoundingClientRect().left + r.clientWidth / 2) {
          st.othersSeen = true;
          if (U.track) U.track('upsell_more_open', { surface: 'popout', offer_id: 'popout|' + current.colourHandle });
        }
      }
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-cn-dev-open]')) { e.preventDefault(); return open(); }
      if (inl && inl.slot.contains(e.target)) {
        // A touch on the card restarts the panel's auto-dismiss countdown (mouse and keyboard
        // are already held by the panel's own mouseenter/focusin).
        if (lastPointer === 'touch' || lastPointer === 'pen') nudge();
        var cq = e.target.closest('[data-dvc-dec]') || e.target.closest('[data-dvc-inc]');
        if (cq) {
          var dec = cq.hasAttribute('data-dvc-dec');
          if (e.detail === 0 && !cq.disabled) cardBump(cq.getAttribute(dec ? 'data-dvc-dec' : 'data-dvc-inc'), dec ? -1 : 1);
          return;
        }
        var cs = e.target.closest('[data-dvc-strength]');
        if (cs) {
          inl.strength = cs.getAttribute('data-dvc-strength');
          if (U.track) U.track('upsell_strength_pick', { surface: 'panel', offer_id: 'panel|' + current.colourHandle, strength: inl.strength });
          drawCard();
          var f = inl.slot.querySelector('[data-dvc-strength="' + inl.strength + '"]');
          return f && f.focus();
        }
        var ca = e.target.closest('[data-dvc-add]');
        if (ca && !ca.disabled) return cardAdd(ca);
        return;
      }
      var b = box(); if (!b || b.hidden) return;
      if (e.target === b || e.target.closest('[data-dvp-close]')) { e.preventDefault(); return close(); }
      // +/- are handled on pointerdown (instant); here only keyboard activation (detail 0).
      var dq = e.target.closest('[data-dvp-dec]');
      if (dq) { if (e.detail === 0 && !dq.disabled) bump(dq.getAttribute('data-dvp-dec'), -1); return; }
      var iq = e.target.closest('[data-dvp-inc]');
      if (iq) { if (e.detail === 0 && !iq.disabled) bump(iq.getAttribute('data-dvp-inc'), 1); return; }
      var s = e.target.closest('[data-dvp-strength]');
      if (s) {
        st.strength = s.getAttribute('data-dvp-strength');
        if (U.track) U.track('upsell_strength_pick', { surface: 'popout', offer_id: 'popout|' + current.colourHandle, strength: st.strength });
        draw(); return refocus('[data-dvp-strength="' + st.strength + '"]');
      }
      var a = e.target.closest('[data-dvp-add]');
      if (a && !a.disabled) return add(a);
    });
    var pn = panel();
    if (pn) ['mouseleave', 'focusout'].forEach(function (evt) { pn.addEventListener(evt, reassert); });
    document.addEventListener('keydown', function (e) {
      var b = box(); if (!b || b.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); close(); return; }
      if (e.key === 'Tab') {
        var f = b.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (!b.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
